import * as filter from '@/store/modules/claim/filter.js'
import moment from 'moment'
import lo from 'lodash'

export const namespaced = true

export const modules = {
  filter
}

export const state = {
}

export const getters = {
  statusesHistory (state, getters, rootGetters) {
    const statusesHistory = rootGetters.claim.claims.reduce((acc, claim) => {
      return claim.status_history.reduce((acc, sta) => {
        acc.push({
          id: claim.id,
          title: claim.title,
          status_id: sta.status_id,
          manager_id: sta.manager_id,
          manager_name: sta.manager_name,
          department_id: sta.department_id,
          department_name: sta.department_name,
          datetime: sta.datetime,
          priority_id: claim.priority_id
        })
        return acc
      }, acc)
    }, [])
    return lo.sortBy(statusesHistory, (o) => {
      return moment(o.datetime).unix()
    }).reverse()
  },
  filteredStatusesHistory (state, getters) {
    return getters.statusesHistory.filter((claim) => {
      return getters['filter/department'] ? getters['filter/department'] === claim.department_id : true
    }).filter((claim) => {
      return getters['filter/manager'] !== null ? claim.manager_id === getters['filter/manager'] : true
    }).filter((claim) => {
      return getters['filter/status'].length > 0
        ? getters['filter/status'].includes(claim.status_id)
        : true
    }).filter((claim) => {
      return getters['filter/priority'].length > 0
        ? getters['filter/priority'].includes(claim.priority_id)
        : true
    }).filter((claim) => {
      const dr = getters['filter/dateRange']
      if (dr) {
        const range = moment().range(moment(dr.start), moment(dr.end))
        const claimDate = new Date(moment(claim.datetime).toDate().setHours(0, 0, 0, 0))
        return range.contains(claimDate)
      } else {
        return true
      }
    })
  }
}
